import ExerciseSection from "./exercise-section";
import TopicsSection from "../../../Mainpages/Topics/components/TopicsSection.jsx";
import quizAdjadvData from "../../../Shared/Activities/Data/quiz/adj-adv-quiz.json";
import quizZerocondData from "../../../Shared/Activities/Data/quiz/zero-cond-quiz.json";
import quizCauseeffectData from "../../../Shared/Activities/Data/quiz/cause-effect-quiz.json";
import quizCollocationsData from "../../../Shared/Activities/Data/quiz/collocations-quiz.json";
import quizComparisonData from "../../../Shared/Activities/Data/quiz/comparison-quiz.json";
import quizDeductionData from "../../../Shared/Activities/Data/quiz/modals-deduction-quiz.json";
import quizDescriptiveAdjectivesData from "../../../Shared/Activities/Data/quiz/descriptive-adjectives-quiz.json";
import quizDeviceVerbsData from "../../../Shared/Activities/Data/quiz/device-verbs-quiz.json";
import quizDependentPrepsData from "../../../Shared/Activities/Data/quiz/dependent-prepositions-quiz.json";
import quizEdingData from "../../../Shared/Activities/Data/quiz/ed-ing-quiz.json";
import quizFirstcondData from "../../../Shared/Activities/Data/quiz/first-cond-quiz.json";
import quizFutureData from "../../../Shared/Activities/Data/quiz/future-quiz.json";
import quizGerundsData from "../../../Shared/Activities/Data/quiz/gerunds-quiz.json";
import quizGerundsInfinitivesData from "../../../Shared/Activities/Data/quiz/gerunds-infinitives-quiz.json";
import quizCanData from "../../../Shared/Activities/Data/quiz/can-quiz.json";
import quizMoneyIdiomsData from "../../../Shared/Activities/Data/quiz/money-idioms-quiz.json";
import quizHabitsData from "../../../Shared/Activities/Data/quiz/habits-quiz.json";
import quizIndirectSpeechData from "../../../Shared/Activities/Data/quiz/indirect-speech-quiz.json";
import quizInfinitivesData from "../../../Shared/Activities/Data/quiz/infinitives-quiz.json";
import quizIntroductionsData from "../../../Shared/Activities/Data/quiz/introductions-quiz.json";
import quizLinkingwordsData from "../../../Shared/Activities/Data/quiz/linking-words-quiz.json";
import quizObligationData from "../../../Shared/Activities/Data/quiz/modals-obligation-quiz.json";
import quizPassiveData from "../../../Shared/Activities/Data/quiz/passive-quiz.json";
import quizPassiveGetData from "../../../Shared/Activities/Data/quiz/passive-get-quiz.json";
import quizPassiveReportingData from "../../../Shared/Activities/Data/quiz/passive-reporting-quiz.json";
import quizPassiveBeingData from "../../../Shared/Activities/Data/quiz/passive-being-quiz.json";
import quizPastContinuousData from "../../../Shared/Activities/Data/quiz/past-continuous-quiz.json";
import quizPerfectPastData from "../../../Shared/Activities/Data/quiz/perfect-past-quiz.json";
import quizPresentContinuousData from "../../../Shared/Activities/Data/quiz/present-continuous-quiz.json";
import quizPresentPerfectData from "../../../Shared/Activities/Data/quiz/present-perfect-quiz.json";
import quizPunctuationData from "../../../Shared/Activities/Data/quiz/punctuation-quiz.json";
import quizProvideVerbData from "../../../Shared/Activities/Data/quiz/provide-verb-quiz.json";
import quizRelativeClausesData from "../../../Shared/Activities/Data/quiz/relative-clauses-quiz.json";
import quizReportedspeechData from "../../../Shared/Activities/Data/quiz/reported-speech-quiz.json";
import quizSecondcondData from "../../../Shared/Activities/Data/quiz/second-cond-quiz.json";
import quizSenseData from "../../../Shared/Activities/Data/quiz/sense-quiz.json";
import quizSimplePastData from "../../../Shared/Activities/Data/quiz/simple-past-quiz.json";
import quizSimplePresentData from "../../../Shared/Activities/Data/quiz/simple-present-quiz.json";
import quizSoenoughData from "../../../Shared/Activities/Data/quiz/so-enough-quiz.json";
import quizSosuchData from "../../../Shared/Activities/Data/quiz/so-such-quiz.json";
import quizSomeanyData from "../../../Shared/Activities/Data/quiz/some-any-quiz.json";
import quizSuggestData from "../../../Shared/Activities/Data/quiz/suggest-quiz.json";
import quizTenseData from "../../../Shared/Activities/Data/quiz/tense-quiz.json";
import quizThirdcondData from "../../../Shared/Activities/Data/quiz/third-cond-quiz.json";
import quizToBePresentData from "../../../Shared/Activities/Data/quiz/to-be-present-quiz.json";
import quizToBePastData from "../../../Shared/Activities/Data/quiz/to-be-past-quiz.json";
import quizUnlessData from "../../../Shared/Activities/Data/quiz/unless-quiz.json";
import quizUsedtoData from "../../../Shared/Activities/Data/quiz/used-to-quiz.json";
import quizWishData from "../../../Shared/Activities/Data/quiz/wish-quiz.json";
import quizWordformsData from "../../../Shared/Activities/Data/quiz/word-forms-quiz.json";
import quizThereIsThereAreData from '../../../Shared/Activities/Data/quiz/there-is-there-are-quiz.json';


import orderingPresentData from "../../../Shared/Activities/Data/ordering/wordorder_present.json";
import orderingPastData from "../../../Shared/Activities/Data/ordering/wordorder_past.json";

import vocabVerbsData from "../../../Shared/Activities/Data/vocab/vocab_verbs.json";
import vocabTravelData from "../../../Shared/Activities/Data/vocab/vocab_travel.json";
import vocabGiftGivingData from "../../../Shared/Activities/Data/vocab/vocab_giftgiving.json";
import vocabBeliefData from "../../../Shared/Activities/Data/vocab/vocab_belief.json";


import gapfillBusinessData from "../../../Shared/Activities/Data/gapfill/gapfill_business.json";



import readingParentsFootballMatch from "../../../Shared/Activities/Data/reading/readingParentsFootball.jsx";
import readingStreamingFatigue from "../../../Shared/Activities/Data/reading/readingStreamingFatigue.jsx";
import readingEssityAccount from "../../../Shared/Activities/Data/reading/readingEssityAccount.jsx";
import readingSimplePresent from "../../../Shared/Activities/Data/reading/readingSimplePresent.jsx";

import videoPhones from "../../../Shared/Activities/Data/videos/phones.jsx";
import videoSpotify from "../../../Shared/Activities/Data/videos/spotify.jsx";





const ExerciseRouter = ({ type, subtype, scrollTargetRef }) => {
    const getDataByType = (type, subtype) => {
      switch (type) {
        case "quiz":
          switch (subtype) { 
            case "adjadv":
              return quizAdjadvData;
            case "zerocond":
              return quizZerocondData;
            case "causeeffect":
              return quizCauseeffectData;
            case "collocations":
              return quizCollocationsData;
            case "comparison":
              return quizComparisonData;
            case "deduction":
              return quizDeductionData;
            case "descriptiveadjectives":
              return quizDescriptiveAdjectivesData;
            case "deviceverbs":
              return quizDeviceVerbsData;
            case "dependentpreps":
              return quizDependentPrepsData;
            case "eding":
              return quizEdingData;
            case "firstcond":
              return quizFirstcondData;
            case "future":
              return quizFutureData; 
            case "gerunds":
              return quizGerundsData;
            case "gerundsinfinitives":
              return quizGerundsInfinitivesData;
            case "can":
              return quizCanData; 
            case "moneyidioms":
              return quizMoneyIdiomsData;
            case "indirectspeech":
              return quizIndirectSpeechData;
            case "infinitives":
              return quizInfinitivesData;
            case "introductions":
              return quizIntroductionsData;
            case "linkingwords":
              return quizLinkingwordsData;
            case "obligation":
              return quizObligationData;
            case "passive":
              return quizPassiveData;
            case "passiveget":
              return quizPassiveGetData;
            case "passivereporting":
              return quizPassiveReportingData;
            case "passivebeing":
              return quizPassiveBeingData;
            case "pastcontinuous":
              return quizPastContinuousData;
            case "perfectpast":
              return quizPerfectPastData;
            case "presentcontinuous":
              return quizPresentContinuousData;
            case "presentperfect":
              return quizPresentPerfectData;
            case "punctuation":
              return quizPunctuationData;
            case "provideverb":
              return quizProvideVerbData;
            case "relativeclauses":
              return quizRelativeClausesData;
            case "reportedspeech":
              return quizReportedspeechData;
            case "secondcond":
              return quizSecondcondData;
            case "sense":
              return quizSenseData;
            case "simplepast":
              return quizSimplePastData;
            case "simplepresent":
              return quizSimplePresentData;
            case "soenough":
              return quizSoenoughData;
            case "sosuch":
              return quizSosuchData;
            case "someany":
              return quizSomeanyData;
            case "suggest":
              return quizSuggestData;
            case "tense":
              return quizTenseData;
            case "thirdcond":
              return quizThirdcondData;
            case "tobepresent":
              return quizToBePresentData;
            case "tobepast":
              return quizToBePastData;
            case "unless":
              return quizUnlessData;
            case "usedto":
              return quizUsedtoData;
            case "wish":
              return quizWishData;
            case "wordforms":
              return quizWordformsData;
            case 'thereisthereare':
              return quizThereIsThereAreData;
            case "habits":
              return quizHabitsData;
            default:
              return quizPassiveData;
          }


        case "ordering":
          switch (subtype) {
            case "present":
              return orderingPresentData;
            case "past":
              return orderingPastData;
            default:
              return orderingPresentData;
          }
        case "vocab":
          switch (subtype) {
            case "verbs":
              return vocabVerbsData;
            case "travel":
              return vocabTravelData;
              case "giftgiving":
                return vocabGiftGivingData;
              case "belief":
                return vocabBeliefData;                 
            default:
              return vocabGiftGivingData;
          }
          case "gapfill":
            switch (subtype) {
              case "business":
                return gapfillBusinessData;
              default:
                return gapfillBusinessData;
          }
            case "reading":
              switch (subtype) {
                case "parents-football-match":
                  return readingParentsFootballMatch;
                case "streaming-fatigue":
                  return readingStreamingFatigue;          
                case "essityaccount":
                  return readingEssityAccount;                  
                case "simplepresent":
                  return readingSimplePresent;        
                  default:
                return readingParentsFootballMatch;   
                }
                case "video":
              switch (subtype) {
                case "phones":
                  return videoPhones;
                case "spotify":
                  return videoSpotify;       
                  default:
                return videoPhones;   
                }
              default:
                return null;
      }
    };
   
    const data = getDataByType(type, subtype);
    if (!data) {
      return <div>Loading...</div>;
    }
   
      if (
         (type === "quiz" && (!data || !Array.isArray(data.questions))) ||
        (type === "ordering" && (!data || !Array.isArray(data))) ||
        (type === "vocab" && (!data || !Array.isArray(data.cards))) ||
        (type === "gapfill" && (!data || typeof data !== "object")) ||
        (type === "grammar" && (!data || !Array.isArray(data.sentences))) ||
        (type === "reading" && !data) ||
        (type === "video" && !data)

      ) {
        return <div>Error: Invalid data format for {type}.</div>;
      }

    // Quizzes are rendered by TopicsSection so that grammar-page quizzes and
    // topic-page quizzes use the exact same component, filters and results
    // screen. ExerciseSection still handles the other activity types.
    if (type === "quiz") {
      return <TopicsSection type="quiz" data={data} />;
    }

    return <ExerciseSection type={type} data={data} id={subtype} scrollTargetRef={scrollTargetRef} />;
  };
  
  export default ExerciseRouter;

